module.exports = __webpack_public_path__ + "static/media/cups_left.db2a4d6d.webp";